import { createReducer } from '@reduxjs/toolkit';

import getNextIncrementValue from '../../thunks/general/getNextIncrementValue';

const initialState = {
  loading: false,
  error: null,
  data: {
    co_order_id: ''
  },
};

const getNextIncrementValueReducer = createReducer(initialState, {
  [getNextIncrementValue.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getNextIncrementValue.fulfilled]: (state, { payload }) => ({
    ...state,
    data: {
      ...state.data,
      ...payload
    },
    loading: false,
  }),
  [getNextIncrementValue.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getNextIncrementValueReducer;
